"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALERT_USES = exports.ALERT_TYPES = void 0;
var ALERT_TYPES = {
  info: 'alert-info private-alert--info',
  warning: 'alert-warning private-alert--warning',
  success: 'alert-success private-alert--success',
  danger: 'alert-danger private-alert--danger',
  tip: 'private-alert--tip'
};
exports.ALERT_TYPES = ALERT_TYPES;
var ALERT_USES = {
  default: '',
  inline: 'private-alert--inline'
};
exports.ALERT_USES = ALERT_USES;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/alert/AlertTypes.js
// module id = 653
// module chunks = 209 210 211 212